/** @format */

import React, { useEffect, useState } from "react";
import UploadButton from "components/UploadButton";
import CategoryChips from "components/Chips";
import ReferenceImage from "components/ReferenceImages";
import { useAppStore } from "store/useAppStore";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import ShareIcon from "../../assets/icons/ShareIcon";
import Button from "components/Button";
import GenerateImageFrame from "components/GenerateImageFrame";
import GradientButton from "components/GradientButton";
import HowItWorksModalWeb from "components/HowItWorksWeb";
import UploadGarmentsCard from "components/1tyons/UploadGarmentCard";

interface WebUploadImageScreenProps {
  handleSelectedImage: (url: string) => void;
  handleUpperGarmentUpload: (event: any) => void;
  handleLowerGarmentUpload: (event: any) => void;
  selectedImageStyle: string;
  setUpperGarmentImageUrl: any;
  setLowerGarmentImageUrl: any;
  generatedImage: string;
  downloadImage: () => void;
  shareImage: () => void;
  selectedImageCategory: any;
  enableButton: boolean;
  onGenerateImage: () => void;
  gender: any;
  age: any;
  onAgeSelect: any;
  onGenderSelect: any;
}

const WebUploadImageScreen = ({
  setUpperGarmentImageUrl,
  setLowerGarmentImageUrl,
  handleSelectedImage,
  handleUpperGarmentUpload,
  handleLowerGarmentUpload,
  selectedImageStyle,
  downloadImage,
  shareImage,
  selectedImageCategory,
  enableButton,
  onGenerateImage,
  gender,
  age,
  onAgeSelect,
  onGenderSelect,
}: WebUploadImageScreenProps) => {
  const generatedImageUrl = useAppStore()?.generatedImageUrl;
  const upperGarmentImageUrl = useAppStore().upperGarmentImageUrl;
  const lowerGarmentImageUrl = useAppStore().lowerGarmentImageUrl;
  const clearUpperGarmentImageUrl = useAppStore().clearUpperGarmentImageUrl;
  const clearLowerGarmentImageUrl = useAppStore().clearLowerGarmentImageUrl;
  const [isLoaded, setIsLoaded] = useState(false);
  console.log(selectedImageCategory, "selectedImageCategory");

  const handleGenderClick = (gender: string) => {
    onGenderSelect(gender);
  };

  const handleAgeCategoryClick = (ageCategory: string) => {
    onAgeSelect(ageCategory);
  };

  const handleClearUpperGarmentImage = () => {
    clearUpperGarmentImageUrl("");
  };

  const handleClearLowerGarmentImage = () => {
    clearLowerGarmentImageUrl("");
  };

  return (
    <div className="h-[100vh]">
      <div className="h-[8vh] w-full grid grid-cols-[1fr,1fr,2fr]">
        <div className="bg-[#222327] w-full h-full !border-r"></div>
        <div className="bg-[#222327] w-full h-full border-r"></div>
        <div className="bg-[#000] w-full h-full"></div>
      </div>
      <div className="w-full h-[92vh] grid grid-cols-[1fr,1fr,2fr]">
        <div className="p-[2rem] flex flex-col gap-[2rem] overflow-scroll border-r border-lightborder">
          <p className="text-[1.1rem] font-medium text-secondary mb-[-1rem]">
            Step 1/2
          </p>
          <div className="pb-[2rem] border-b border-lightborder">
            <UploadGarmentsCard
              title="Upper Garment"
              placeholder={`Please share a photo of the Upper Garment`}
              uploadedImageUrl={upperGarmentImageUrl}
              handleUpload={(event: any) => handleUpperGarmentUpload(event)}
              clearImage={handleClearUpperGarmentImage}
            />
          </div>
          {/* <div>
                  <UploadGarmentsCard
                     title="Lower Garment"
                     placeholder="Please share a photo of the Lower Garment"
                     uploadedImageUrl={lowerGarmentImageUrl}
                     handleUpload={(event: any) => handleLowerGarmentUpload(event)}
                     clearImage={handleClearLowerGarmentImage}
                  />
               </div> */}
        </div>
        <div className="bg-black w-full h-[92vh] px-[1rem] py-[2rem] border-r border-lightborder overflow-scroll">
          <p className="text-[1.1rem] font-medium text-secondary mb-[1rem]">
            Step 2/2
          </p>
          <h3 className="text-[1.6rem] font-semibold text-white mb-[1rem]">
            Choose a model
          </h3>
          <div className="flex flex-col gap-[1rem]">
            <div className="border-b pb-[1rem] border-lightborder">
              <p className="text-[1.3rem] font-semibold text-white mb-[1rem]">
                Select Gender
              </p>
              <div className="flex gap-[1rem] justify-center">
                <div onClick={() => handleGenderClick("MALE")}>
                  <img
                    src={
                      "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/amc0jwgl1uo2dlh4ojks"
                    }
                    className={`w-[7rem] h-[7rem] border-4 rounded-full ${
                      gender === "MALE" ? "border-turquoise" : "border-black"
                    }`}
                  />
                  <p className="text-white text-[1.2rem] font-semibold text-center">
                    Male
                  </p>
                </div>
                <div onClick={() => handleGenderClick("FEMALE")}>
                  <img
                    src={
                      "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/fjke25fvlbpgv9uvvegg"
                    }
                    className={`w-[7rem] h-[7rem] border-4 rounded-full ${
                      gender === "FEMALE" ? "border-turquoise" : "border-black"
                    }`}
                  />
                  <p className="text-white text-[1.2rem] font-semibold text-center">
                    Female
                  </p>
                </div>
                {/* <span
                  onClick={() => handleGenderClick("MALE")}
                  className={`font-semibold cursor-pointer hover:bg-turquoise hover:text-black hover:border-turquoise transition-all duration-200 px-5 py-1.5 border-2 rounded-full ${
                    gender !== "MALE"
                      ? "text-white border-white bg-black"
                      : "bg-turquoise border-turquoise"
                  }`}
                >
                  Male
                </span>
                <span
                  onClick={() => handleGenderClick("FEMALE")}
                  className={`font-semibold cursor-pointer hover:bg-turquoise hover:text-black hover:border-turquoise transition-all duration-200 px-5 py-1.5 border-2 rounded-full ${
                    gender !== "FEMALE"
                      ? "text-white border-white bg-black"
                      : "bg-turquoise border-turquoise"
                  }`}
                >
                  Female
                </span> */}
              </div>
            </div>
          </div>
          <div className="mt-[1rem]">
            <p className="text-[1.3rem] font-semibold text-white mb-[1rem]">
              Generated Models
            </p>
            <div className="grid grid-cols-2 place-items-center gap-3 max-h-[92%] lg:mb-[3rem] overflow-y-auto rounded-2xl !scrollbar-hide">
              {selectedImageCategory?.map((item: any, index: number) => (
                <div className="w-full">
                  <ReferenceImage
                    key={index}
                    imageUrl={item}
                    selectedImageStyle={(url: string) =>
                      handleSelectedImage(url)
                    }
                    isSelected={selectedImageStyle === item}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        {generatedImageUrl ? (
          <div className="bg-black w-full h-[92vh] px-[2rem] py-[1rem] flex flex-col gap-[2rem] items-center">
            <div className="flex justify-between w-full mt-[2rem]">
              <p className="text-white text-[1.6rem]">Generated Image</p>

              <div className="flex gap-[1.5rem]">
                <div>
                  <Button
                    classname="w-[10rem]"
                    buttonText={"Download"}
                    icon={<DownloadIcon />}
                    onclick={downloadImage}
                  />
                </div>
                <div>
                  <Button
                    classname="w-[10rem]"
                    buttonText={"Share"}
                    icon={<ShareIcon />}
                    onclick={shareImage}
                  />
                </div>
              </div>
            </div>
            <div className="w-[90%] max-w-[640px] h-[85%] ">
              <img
                onLoad={() => setIsLoaded(true)}
                src={generatedImageUrl}
                className={`transition-opacity duration-700 ease-in-out ${
                  isLoaded ? "opacity-100" : "opacity-0"
                } rounded-md h-full w-full `}
                alt="Generated Image"
              />
            </div>
          </div>
        ) : (
          <div className="bg-black w-full h-[92vh] py-[1rem] flex flex-col justify-around items-center">
            {enableButton && (
              <div className="absolute bg-black bg-opacity-60 w-[50%] h-[92vh]"></div>
            )}
            {!generatedImageUrl && (
              <GenerateImageFrame
                enableButton={enableButton}
                generateImage={onGenerateImage}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WebUploadImageScreen;
